// Timestamps in the admin UI are almost always read as "how stale is this",
// not "when exactly" - so they render as "3 hours ago", with the exact value
// kept on the element's title for the rare case you do want it.

const DIVISIONS = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' },
];

// Intl.RelativeTimeFormat rather than a date library: it is built in, and it
// localises the wording for free.
const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

export function relativeTime(timestamp) {
  if (!timestamp) return '';

  const then = new Date(timestamp);
  if (Number.isNaN(then.getTime())) return '';

  let duration = (then.getTime() - Date.now()) / 1000;
  for (const { amount, unit } of DIVISIONS) {
    if (Math.abs(duration) < amount) {
      return formatter.format(Math.round(duration), unit);
    }
    duration /= amount;
  }
  return '';
}
